import React from 'react';

const HavingConversationDropdown = () => {
  return (
    <details className="govuk-details">
      <summary className="govuk-details__summary">
        <span className="govuk-details__summary-text">
          Learn more about &apos;Having Conversations&apos;
        </span>
      </summary>
      <div className="govuk-details__text">
        <h3 className="govuk-heading-s">
          Having conversations and using MyWishes Care
        </h3>
        <p className="govuk-body">
          Please ensure that the following steps are followed.
        </p>
        <ul className="govuk-list govuk-list--bullet">
          <li>
            Add your details in the boxes provided each time you have a
            conversation about the person&apos;s wishes and/or their ACP
            documentation.
          </li>
          <li>
            Every relevant conversation that takes place should be logged and
            added to MyWishes Care.
          </li>
          <li>
            Have at least one conversation with the person&apos;s Next of Kin,
            when it is possible to do so.
          </li>
          <li>
            Have at least one conversation when friend or family member is
            present, when it is possible to do so.
          </li>
          <li>
            Document if the person is happy for conversations about their health
            and social care. circumstances to be discussed with those already
            spoken with in the future.
          </li>
          <li>
            Add the details of anyone who the person would not like any health
            or care discussions to take place with now or in the future.
          </li>
          <li>
            When someone is not willing to have a conversation about their their
            health and social care wishes please update this section
            accordingly. Following this step, refer to your organisations
            procedures and processes for further guidance.
          </li>
          <li>
            When someone is unable to have a conversation about their their
            health and social care wishes please update this section
            accordingly. Following this step, refer to your organisations
            procedures and processes for further guidance.
          </li>
          <li>
            Please use the person&apos;s &apos;Patients Notes&apos; section to
            add further context, provide better person-centred care, flag or
            read any safeguarding concerns.
          </li>
        </ul>
        <h3 className="govuk-heading-s">
          Universal Principles for Advance Care Planning{' '}
        </h3>
        <p className="govuk-body">
          NHS England&apos;s &apos;Universal Principles for Advance Care
          Planning&apos; can be read below
        </p>
        <ol className="govuk-list govuk-list--number">
          <li>
            The person is central to developing and agreeing their advance care
            plan including deciding who else should be involved in the process.
          </li>
          <li>
            The person has personalised conversations about their future care
            focused on what matters to them and their needs.
          </li>
          <li>
            The person agrees the outcomes of their advance care planning
            conversation through a shared decision making process in partnership
            with relevant professionals.
          </li>
          <li>
            The person has a shareable advance care plan which records what
            matters to them, and their preferences and decisions about future
            care and treatment.
          </li>
          <li>
            The person has the opportunity, and is encouraged, to review and
            revise their advance care plan.
          </li>
          <li>
            Anyone involved in advance care planning is able to speak up if they
            feel that these universal principles are not being followed.
          </li>
        </ol>
        <h3 className="govuk-heading-s">Further reading</h3>
        <ul className="govuk-list govuk-list--bullet">
          <li>
            <a
              href="https://www.mariecurie.org.uk/professionals/palliative-care-knowledge-zone/individual-needs/talking-approaching-end-life"
              className="govuk-link"
              rel="noreferrer noopener"
              target="_blank"
            >
              Talking to someone about Dying
            </a>{' '}
            (Marie Curie)
          </li>
          <li>
            <a
              href="https://www.england.nhs.uk/wp-content/uploads/2022/03/universal-principles-for-advance-care-planning.pdf"
              className="govuk-link"
              rel="noreferrer noopener"
              target="_blank"
            >
              Universal Principles for Advance Care Planning
            </a>{' '}
            (NHS England)
          </li>
        </ul>
      </div>
    </details>
  );
};

export default HavingConversationDropdown;
